// extracted by mini-css-extract-plugin
export default {"container":"hawk-view-at-container","peacock":"hawk-view-at-peacock"};